
let weather_brief = document.innerText="https://www.1800wxbrief.com" ; 
let AC00_6b = document.innerText="https://www.faa.gov/documentlibrary/media/advisory_circular/ac_00-6b.pdf";
let AIM = "https://www.faa.gov/air_traffic/publications/atpubs/aim_html/";
let Aviation_weather = "https://www.aviationweather.gov/"; 
let sigmets_airmets = "https://www.aviationweather.gov/gfa/#sigmet";
let graphical_airmets = "https://www.aviationweather.gov/gfa/gairmet";
let progcharts = "https://www.aviationweather.gov/gfa/#progchart";
let wxprediction = "http://www.wpc.ncep.noaa.gov/#page=ovw";
let radar = "https://www.aviationweather.gov/#radar";
//let winds_aloft = "https://aviationweather.gov/data/windtemp";
//let metars = "https://aviationweather.gov/data/metar";
//let tafs = "https://aviationweather.gov/data/taf";
//let winds = "https://aviationweather.gov/data/windtemp/?region=mia&fcst=12&level=low";
let sunset = "https://www.timeanddate.com/sun/usa/atlanta";
let celcius = "https://www.metric-conversions.org/temperature/celsius-to-fahrenheit.htm";
//let weatherClient = "https://weatherclient-phi.vercel.app/";
let notams = "https://notams.aim.faa.gov/notamSearch/nsapp.html#/"
let cfr = "https://www.ecfr.gov/current/title-14/chapter-I/subchapter-F/part-91/subpart-B"
let afd = "https://www.faa.gov/air_traffic/flight_info/aeronav/digital_products/dafd/";
//let dataFaa = "https://catalog.data.faa.gov/dataset"
//let airNav = "https://www.airnav.com/airport"
let skyVector = "https://skyvector.com/";
let termProcedures = "https://www.faa.gov/air_traffic/flight_info/aeronav/digital_products/dtpp/search/";
let adipFaa = "https://adip.faa.gov/agis/public/#/public"






let wx =[
    
    //{id: 1100, type: 'WeatherClient', wx_link:  weatherClient},
    {id: 1110, type: '1-800-WXBrief', wx_link:  weather_brief},
    {id: 1111, type: 'Weather Adivisory Circular', wx_link: AC00_6b},
    {id: 1112, type: 'Airmen Information Manual', wx_link: AIM},
    {id: 1113, type: 'Aviation Weather Center', wx_link: Aviation_weather},
    {id: 1114, type: 'Airmets and Sigmets', wx_link: sigmets_airmets},
    {id: 1115, type: 'Surface Analysis & Prognosis', wx_link: progcharts},
    {id: 1116, type: 'Weather Prediction Center', wx_link: wxprediction},
    {id: 1117, type: 'Graphical Airmets', wx_link: graphical_airmets},
    {id: 1118, type: 'Radar Composite', wx_link: radar},
    //{id: 1119, type: 'Winds Aloft', wx_link: winds_aloft},
    //{id: 1120, type: 'METAR', wx_link: metars},
    //{id: 1121, type: 'TAF', wx_link: tafs},
    //{id: 1122, type: 'SE Winds', wx_link: winds},
    {id: 1123, type: 'Sunset', wx_link: sunset},
    {id: 1124, type: 'Celcius to Fahrenheit', wx_link: celcius},
    {id: 1125, type: 'NOTAMS', wx_link: notams},
    {id: 1126, type: 'CFR', wx_link: cfr},
    {id: 1127, type: 'Chart Supplement: A/FD', wx_link: afd},
    //{id: 1128, type: 'FAA Data Catalog', wx_link: dataFaa},
    //{id: 1129, type: 'AirNav', wx_link: airNav},
    {id: 1130, type: 'SkyVector', wx_link: skyVector},
    {id: 1131, type: 'Terminal Procedures', wx_link: termProcedures},
    {id: 1132, type: 'Airport Data FAA', wx_link: adipFaa},
]

export default wx;